<template>
  <div class="row">
    <div class="col">
      <h1>Logga in</h1>
      <p>
        För att fortsätta krävs det att du är inloggad, klicka på knappen nedan
        för att komma till inloggningen.
      </p>

      <router-link to="signin" class="btn btn-primary" type="button"
        >Logga in</router-link
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { useAuthenticatedUserStore } from "@/modules/authentication/authentication-store";
import util from "../services/util";

const router = useRouter();
const store = useAuthenticatedUserStore();

onMounted(() => {
  if (store.user.isAuthenticated) {
    if (!store.userCanView) {
      router.push({ name: "noplanner" });
    } else if (util.isMobile()) {
      router.push({ name: "mobile" });
    } else {
      router.push({ name: "start" });
    }
  }
});
</script>
